<template>
  <Teleport to="body">
    <Transition name="terms-modal">
      <div
        v-if="isOpen"
        class="terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        @click.self="close"
      >
        <div class="terms-modal__backdrop" aria-hidden="true" />
        <div class="terms-modal__box">
          <button type="button" class="terms-modal__close" aria-label="Закрыть" @click="close">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <h2 id="terms-modal-title" class="terms-modal__title">Пользовательское соглашение</h2>
          <div class="terms-modal__body" v-html="agreementText" />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

const agreementText = `
<p><strong>Пользовательское соглашение интернет-магазина «Prestige Inside»</strong></p>

<h3>1. Общие положения</h3>
<p><strong>1.1.</strong> Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между интернет-магазином «Prestige Inside» (далее — «Продавец» или «Магазин») и Пользователем (далее — «Вы» или «Покупатель») по поводу использования сайта, оформления заказов и приобретения товаров (картин, постеров и аксессуаров), представленных в Магазине.</p>
<p><strong>1.2.</strong> Начиная использовать сайт Магазина (просматривая каталог, регистрируясь, оформляя заказ), Вы безоговорочно принимаете все условия настоящего Соглашения.</p>
<p><strong>1.3.</strong> Если Вы не согласны с условиями Соглашения, Вы не вправе использовать сайт и оформлять заказы.</p>

<h3>2. Оформление заказа и условия покупки</h3>
<p><strong>2.1.</strong> Для оформления заказа Вам необходимо предоставить достоверную контактную информацию (имя, телефон, email, адрес доставки).</p>
<p><strong>2.2.</strong> Размещая заказ, Вы подтверждаете, что ознакомлены с описанием товара (размер, техника исполнения, материалы) и согласны с итоговой стоимостью.</p>
<p><strong>2.3.</strong> Цена товара зависит от выбранного размера и аксессуаров (багет, паспарту, крепления). Чем крупнее формат, тем выразительнее работа смотрится в интерьере.</p>
<p><strong>2.4.</strong> Все изображения товаров в каталоге носят справочный характер. Незначительные отклонения в цветопередаче возможны в зависимости от настроек Вашего экрана.</p>

<h3>3. Оплата и доставка</h3>
<p><strong>3.1.</strong> Способы оплаты и доставки указаны в соответствующих разделах сайта Магазина.</p>
<p><strong>3.2.</strong> Право собственности на товар переходит к Покупателю с момента полной оплаты заказа и получения товара.</p>
<p><strong>3.3.</strong> Продавец обязуется упаковать товар надлежащим образом для обеспечения его сохранности при транспортировке.</p>
<p><strong>3.4.</strong> Сроки доставки являются ориентировочными и зависят от работы транспортных компаний. Продавец не несет ответственности за задержки, возникшие по вине перевозчика.</p>

<h3>4. Возврат и обмен</h3>
<p><strong>4.1.</strong> Покупатель вправе отказаться от товара надлежащего качества до момента его получения, а также в течение 7 дней после получения (если сохранен товарный вид, пломбы, фабричные ярлыки).</p>
<p><strong>4.2.</strong> Возврат товара надлежащего качества осуществляется за счет Покупателя.</p>
<p><strong>4.3.</strong> В случае обнаружения брака или производственного дефекта, Продавец обязуется заменить товар или вернуть денежные средства после проведения проверки качества.</p>
<p><strong>4.4.</strong> Товары, созданные под индивидуальный заказ (например, уникальный размер или оформление), возврату и обмену не подлежат, кроме случаев брака.</p>

<h3>5. Интеллектуальная собственность</h3>
<p><strong>5.1.</strong> Все права на изображения картин, тексты описаний, дизайн сайта и программный код принадлежат Продавцу (или используются по лицензии от авторов).</p>
<p><strong>5.2.</strong> Запрещается копирование, воспроизведение или распространение контента сайта (включая изображения картин) без письменного разрешения правообладателя.</p>
<p><strong>5.3.</strong> Приобретая физическую картину, Вы не приобретаете авторские права на воспроизведение (копирование) этого изображения.</p>

<h3>6. Ограничение ответственности</h3>
<p><strong>6.1.</strong> Информация на сайте предоставляется «как есть». Продавец не гарантирует бесперебойную работу сайта и не несет ответственности за временные технические сбои.</p>
<p><strong>6.2.</strong> Продавец не несет ответственности за возможные убытки, возникшие в результате использования или невозможности использования сайта.</p>
<p><strong>6.3.</strong> Продавец вправе изменять ассортимент, цены и условия акций в любое время без предварительного уведомления.</p>

<h3>7. Заключительные положения</h3>
<p><strong>7.1.</strong> Продавец оставляет за собой право вносить изменения в настоящее Соглашение. Новая редакция вступает в силу с момента её публикации на сайте.</p>
<p><strong>7.2.</strong> Все споры стороны стремятся урегулировать путем переговоров. При недостижении согласия спор разрешается в судебном порядке по месту нахождения Продавца.</p>

<h3>8. Контактная информация</h3>
<p>Все вопросы, связанные с оформлением заказов, оплатой, доставкой и использованием сайта, Вы можете направлять нам по электронной почте или через форму обратной связи, указанные в разделе «Контакты».</p>
`

export default {
  name: 'TermsModal',
  setup() {
    const store = useStore()
    const isOpen = computed(() => store.state.termsModalOpen)

    function close() {
      store.commit('setTermsModalOpen', false)
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close()
    }

    watch(isOpen, (open) => {
      if (open) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
        document.body.style.paddingRight = scrollbarWidth ? `${scrollbarWidth}px` : ''
        document.body.style.overflow = 'hidden'
        window.addEventListener('keydown', onKeydown)
      } else {
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
        window.removeEventListener('keydown', onKeydown)
      }
    })

    return { isOpen, close, agreementText }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

$dur: 0.3s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.terms-modal {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.terms-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

.terms-modal__box {
  position: relative;
  width: 100%;
  max-width: 600px;
  max-height: 85vh;
  overflow-y: auto;
  background: $color-primary-inverse;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2);
  padding: 28px 24px 24px;
}

.terms-modal__close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 50%;
  color: $color-text-muted;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: $color-text;
  }
  svg { width: 20px; height: 20px; }
}

.terms-modal__title {
  font-family: 'Arimo', sans-serif;
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 20px;
  padding-right: 48px;
  color: $color-text;
}

.terms-modal__body {
  font-family: 'Arimo', sans-serif;
  color: $color-text-muted;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.65;
  letter-spacing: 0.01em;

  :deep(p) {
    margin: 0 0 0.85em;
    &:last-child { margin-bottom: 0; }
  }
  :deep(p:first-child) { margin-top: 0; }
  :deep(strong) { color: $color-text; font-weight: 700; }
  :deep(h3) {
    font-family: 'Arimo', sans-serif;
    font-size: 17px;
    font-weight: 700;
    color: $color-text;
    margin: 1.35em 0 0.5em;
    letter-spacing: 0.02em;
    &:first-child { margin-top: 0; }
  }
}

.terms-modal-enter-active,
.terms-modal-leave-active {
  transition: opacity $dur $ease;
  .terms-modal__box {
    transition: transform $dur $ease;
  }
}
.terms-modal-enter-from,
.terms-modal-leave-to {
  opacity: 0;
  .terms-modal__box {
    transform: scale(0.96) translateY(12px);
  }
}
</style>
